import React from "react";
import styles from "./style.scss";

interface Props {
  title?: string;
}

export const Source: React.FC<Props> = ({ title }) => {
  if (!title) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.sourceContainer}>
        <div className={styles.text}>{title}</div>
      </div>
    </div>
  );
};
